import React, { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import $ from "jquery";
import "bootstrap-datepicker";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import moment from "moment";
import Layout from "../../../Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  useAddAdminMutation,
  useEditAdminMutation,
} from "../../../store/Api/admins";
import { useGetRrbQuery } from "../../../store/Api/common";
import {  hidetoast, useDecodeToken } from "../../../Utils/function";
import CreateAuditsImagesUi from "./CreateAuditsImagesUi";
import { useAddAuditImagesMutation, useEditAuditsImagesMutation } from "../../../store/Api/auditsImages";
// Define validation schema using Yup
// const validationSchema = Yup.object({
//   image_name: Yup.string()
//     .required("Please enter your Image Title")
//     .min(2, "First name must be at least 2 characters long"),
// });

function CreateAuditsImages() {
  const dispatch = useDispatch();
  // const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation(); // Access state
  const decodedToken = useDecodeToken();
  const { state } = location;
  const id = state?.row?.id
  const [addAuditImage] = useAddAuditImagesMutation();
  const [updateAuditImage] = useEditAuditsImagesMutation();
  const { data, isFetching, isLoading } = useGetRrbQuery({});
  const [isTitleError, setIsTitleError] = useState("");
  const toast = useSelector((state) => state.toast);

  // Auto-hide toast after 3 seconds
 useEffect(() => {
    if (toast.message) {
       hidetoast()
    }
  }, [toast.message, dispatch]);
  const handleSubmit = async (values) => {
    // const trimmedValues = Object.fromEntries(
    //   Object.entries(values).map(([key, value]) => [
    //     key,
    //     typeof value === "string" ? value.trim() : value,
    //   ])
    // );
    let isError = false;
    if (values.titles) {
      values.titles.forEach((name) => {
        if (!name.trim()) {
          isError = true;
        }
      });
    } else {
      isError = true;
    }
    if (isError) {
      setIsTitleError("Title is required");
    } else {
      const data = id
        ? {
            title: values?.titles[0],
          }
        : {
            titles: values?.titles,
          };
              try {
        const response = id
          ? await updateAuditImage({ id, data })
          : await addAuditImage(data);
        if (response?.data?.success) {
          navigate("/audits-images");
        }
      } catch (error) {
        console.log(error, "add image title error");
      }
    }
  };
  const addNewTitleField = (formik) => {
    const currenttitles = formik.values?.titles || [];
    formik.setFieldValue("titles", [...currenttitles, ""]);
  };

  const handleTitleChange = (formik, index, value) => {
    const currenttitles = [...formik.values?.titles];
    currenttitles[index] = value;
    formik.setFieldValue("titles", currenttitles);
    setIsTitleError("");
  };

  const removeTitleField = (formik, index) => {
    const currenttitles = [...formik.values?.titles];
    currenttitles.splice(index, 1);
    formik.setFieldValue("titles", currenttitles);
  };
  
  return (
    <Layout>
      <Formik
        initialValues={
          id
            ? {
                titles: [state?.row?.title],
              }
            : {
                titles: [""],
              }
        }
        // validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <CreateAuditsImagesUi
            formik={formik}
            id={id}
            addNewTitleField={() => addNewTitleField(formik)}
            handleTitleChange={(index, value) =>
                handleTitleChange(formik, index, value)
            }
            removeTitleField={(index) => removeTitleField(formik, index)}
            isTitleError={isTitleError}
            toast={toast}
          />
        )}
      </Formik>
    </Layout>
  );
}

export default CreateAuditsImages;
